import React from 'react';
import { Button } from '../../../../components/shared';
import { useLanguage } from '../../../../hooks/shared';

interface EmptyDayStateProps {
  onAddTraining?: () => void;
  className?: string;
}

/**
 * Component for displaying empty day state (no trainings)
 */
export const EmptyDayState: React.FC<EmptyDayStateProps> = ({
  onAddTraining,
  className = '',
}) => {
  const { t } = useLanguage();

  return (
    <div className={`text-center py-12 ${className}`}>
      <div className="text-gray-400 text-6xl mb-4">🏃‍♀️</div>
      <p className="text-gray-600 text-lg mb-6">{t('calendar.noTrainings')}</p>
      {onAddTraining && (
        <Button
          className="bg-gradient-to-r from-blue-600 to-purple-600"
          onClick={onAddTraining}
        >
          {t('calendar.addTraining')}
        </Button>
      )}
    </div>
  );
};
